import { render, staticRenderFns } from "./ParentProductAnalysis.vue?vue&type=template&id=fd29890c"
import script from "./ParentProductAnalysis.vue?vue&type=script&lang=js"
export * from "./ParentProductAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ParentProductAnalysis.vue?vue&type=style&index=0&id=fd29890c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports